module.exports = {
	home: {
		bindAccountTitle: '계정 연동',
		getNameTitle: 'ID 설정',
		linkAccountTitle: '관련 계정',
		yinjicode: '연동 코드',
		changePsw: '설정/비밀번호 변경',
		cancelAccountTitle: '게스트 계정 삭제',
		// loginDeviceTitle: '로그인 기기 관리',
		bindAccountBtn: 'FUNDOLL PASS 계정 연동',
		accountTitle: '계정',
		checkAccountBtn: '계정 변경',
		changePswTitle: '비밀번호 변경',
		clickPswTitle: '탭 하여 수정',
		binded: '연동됨',
		goChangeBind: '연동 변경',
		goBind: '연동하러 가기',
		emailBindTitle: '이메일 연동',
		privacyTitls: '개인정보 보호지침',
		FAQTitle: 'FAQ',
		kefu: '고객센터',
		logOffTitle: '계정 탈퇴',
		accountTitle1: '아이디',
		accountIdTitle: '계정 아이디',
		changeEmailBtn: '연동 이메일 변경',
		touristName: '게스트 사용자',
		touristTitle: '인증 완료',
		logOut: '로그 아웃',
		setNameTitle: '사용하실 아이디를 입력하세요.',
		bindAccountsTips:
			'안내: 아이디 설정 시 게임 내 캐릭터 명을 사용할 수 없습니다.',
		gotoBindBtn: '연동하러 가기',
		query: '검색 센터',
	},
	toast: {
		verifycodeBtn: '받기',
		verifycodeBtn2: '다시 받기',
		comfirmBtn1: '확인',
		comfirmBtn2: '취소',
		emailPlaceholder: '이메일 입력',
		setNamePlaceholder: '아이디 입력',
		setNameTitls: '8~16자, 알파벳 1자와 숫자만 입력 가능',
		verifyTitle: '인증 코드 입력',
		pswTitle1: '새 비밀번호 입력',
		pswTitle2: '새 비밀번호 재입력',
		comfirmPswTips: '동일한 비밀번호를 입력하셔야 합니다.',
		verifypswTips: '비밀번호 입력(6~18자,알파벳, 띄어쓰기 불가)',
		newverifypswTips: '비밀번호 입력',
		verifyemailTips: '포맷 오류로 확인할 수 없습니다. 다시 입력하세요.',
		noEmail: '연동할 이메일 입력',
		longTime: '입력 시간이 초과되어 다시 인증해야 합니다.',
		noInfo: '데이터를 수집할 수 없습니다.',
		binded: '해당 계정은 연동되었습니다. 문의가 필요하시면 고객센터에 문의해 주세요.',
		banCancelAccount:
			'현재 연동된 {name} 계정의 연동을 해제할 수 없습니다.',
		noEmail1: '이메일 입력',
		logout1: '기기 로그아웃 성공',
	},
	logoff: {
		logoffTipsText1:
			'1. 계정 탈퇴를 신청하신 날부터 15일 이내에 고객님의 계정의 탈퇴가 완료되며, 만약 15일 이내에 고객님께서 게임에 해당 계정으로 로그인하시면 해당 탈퇴 신청은 철회됩니다.',
		logoffTipsText2:
			'2. 계정 탈퇴 성공 후 고객님의 계정은 영구적으로 사용하실 수 없게 됩니다.',
		logoffTipsText3:
			'3. 해당 부분에 대해 문의가 필요하시다면 고객센터에 문의해 주시기 바랍니다. (월~일 10:00~19:00)',
		logoffTipsBtn: '확인',
		text1: '고객님의 계정을 보호하기 위해',
		text2: '고객님의 계정 탈퇴 신청이 접수되었습니다.',
		text11: '고객님의 계정 탈퇴 신청이 접수되었습니다.',
		text3: `고객님의 계정 탈퇴 신청은 {time}에 접수되었으며, 현재 고객님의 계정은 탈퇴 절차 진행 중입니다.`,
		text4: `고객님의 계정 탈퇴는 {time}에 완료되며 탈퇴가 완료되기 전에 해당 계정으로 로그인하시면 탈퇴 절차는 자동으로 철회됩니다.`,
		text5: '안내',
		text9: '서버',
		text7: '캐릭터',
		text8: '레벨',
		text10: '탈퇴 안내를 자세히 읽어주세요.',
		text6: '삭제 확인 시 고객님의 게스트 계정은 신규 계정으로 초기화되며 현재까지의 게임 데이터가 모두 삭제되고 다시 플레이하실 수 없게됩니다. 신중히 선택해주세요.',
		tourText2: '게임',
		tourText3: '게임 캐릭터',
		tourText4: '게임 UID',
		tourText5: '게임 레벨',
		logoffScuessTips:
			'계정 탈퇴를 신청하셨습니다. 해당 계정이 로그아웃됩니다',
		agreementTips: '{name}을 읽고 동의합니다',
		buttonText: '읽음',
		buttonText1: '탈퇴하러 가기',
	},
	title: {
		title: '프로필',
		title1: '개인정보 보호지침',
		title2: 'FAQ',
		title3: '고객센터',
		title4: '보안 인증',
		title5: '계정 연동',
		title6: '이메일 연동',
		title7: '비밀번호 변경',
		title8: '탈퇴 안내',
		title9: '계정 탈퇴 신청 안내',
		title10: '아이디 설정',
		title11: '계정 연동 해제',
		title12: '관련 계정',
		title13: '탈퇴 안내',
		title14: '탈퇴 확인',
		title15: '계정 탈퇴 신청 안내',
		title16: '로그인 기기 관리',
		title18: '연동 이메일 변경',
		title19: '아이디 설정',
		netError:
			'네트워크 오류로 인해 진행이 불가합니다. 네트워크 환경을 확인해주시기 바랍니다.',
		title20: '탈퇴 안내',
		title21: '개인정보 보호지침',
		title22: '이용 약관',
	},
	verifyText: {
		titleTxt1:
			'고객님의 계정을 보호하기 위해, 신규 아이디를 설정하기 전에 해당 계정에 연동된 이메일을 인증하세요.',
		titleTxt2:
			'고객님의 계정을 보호하기 위해, 관련 계정을 설정하기 전에 해당 계정에 연동된 이메일을 인증하세요.',
		titleTxt3:
			'고객님의 계정을 보호하기 위해, 비밀번호를 변경하기 전에 해당 계정에 연동된 이메일을 인증하세요.',
		titleTxt4:
			'고객님의 계정을 보호하기 위해, 기기 관리를 진행하기 전에 해당 계정에 연동된 이메일을 인증하세요.',
		titleTxt5:
			'고객님의 계정을 보호하기 위해, 신규 이메일을 연동하기 전에 기존에 연동하신 이메일을 인증하세요.',
		titleTxt6:
			'고객님의 계정을 보호하기 위해, 이메일 연동을 해제하기 전에 기존에 연동하신 이메일을 인증하세요.',
		title1: '이메일',
	},
	successText: {
		goBack: '돌아가기',
		successTitle1: '연동 성공',
		successTitle2: '연동 변경 성공',
		successTitle3: '연동 이메일 변경 성공',
		successTitle4: '설정 성공',
	},
	bindAccountText: {
		text1: '연동 변경',
		text2: '연동',
		text3: '계정 보유 중',
		text4: '가입 및 연동',
		text5: '고객님의 계정을 보호하기 위해, 계정을 연동하기 전에 기존에 연동하신 이메일을 인증하세요.',
		text6: 'FUNDOLL 계정 연동',
		text7: 'PASS 계정/이메일/ID를 입력하세요',
		text8: '고객님의 계정은 이미 연동되었습니다. 문제 발생 시 고객센터에 문의해 주시기 바랍니다.',
	},
	preamble: {
		tx1: '해당 기기에서 데이터 연동 코드를 수령하시면, 계정의 게임 데이터는 해당 기기에서 삭제되며, 다른 기기로 이관됩니다. 기존에 사용하던 기기에서 기존 게임 데이터를 사용하실 수 없습니다.',
		tx2: '데이터 연동 코드',
		tx3: '기기에서 데이터 연동 코드를 수령한 후에는 다른 기기에서 해당 게임 데이터를 사용할 수 있으며, 그와 동시에 해당 기기에서 게임 데이터가 삭제됩니다.',
		tx4: '데이터 연동 코드 확인',
		tx5: '계정 연동을 원하시면 데이터 연동 코드를 입력해주세요',
		tx6: '데이터 연동 코드 비밀번호',
		tx7: '(데이터 연동 코드 발급 시 비밀번호를 설정하지 않았다면, 해당 란에 입력할 필요없음)',
		tx8: '계정 연동을 원하시면 데이터 연동 코드의 비밀번호를 입력해주세요',
		tx9: '해당 계정의 데이터 연동 코드와 동일한 비밀번호를 사용할 수 없습니다',
		tx10: '게임 캐릭터를 보유하지 않음',
		tx11: "'연동 확인'을 탭한 후에는 기존 기기에서 게임에 로그인할 수 없습니다",
		tx12: '연동 확인',
		tx13: '연동 성공!',
		tx14: '(데이터 연동 비밀번호 설정 후 변경 불가)',
		tx15: '복사',
		tx16: '비밀번호를 설정하셨습니다!',
		tx17: '복사 완료!',
		tx18: '복사 실패, 수동으로 복사해주세요!',
	},
};
